import type { Project } from '../types/crm';

export function nextProjectReferenceNo(projects: Project[]): string {
  const prefix = `PRJ-${new Date().toISOString().slice(2, 7).replace('-', '')}-`;
  const count =
    projects.filter((p) => p.reference_no?.startsWith(prefix)).length + 1;
  return `${prefix}${String(count).padStart(3, '0')}`;
}
